import React, { useEffect, useState } from "react";
import { Button, Modal, Table, Row, Col } from "react-bootstrap";
import ToolkitProvider, {
    Search,
    CSVExport,
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import axios from "axios";
import { MdDeleteOutline } from "react-icons/md";
import { FaCheck, FaEdit, FaEyeDropper } from "react-icons/fa";
import { FaEye, FaEyeLowVision, FaEyeSlash } from "react-icons/fa6";
import { BsEyeFill } from "react-icons/bs";
const AdminEnquiry = () => {

    const [show, setShow] = useState(false);
    const [editid, seteditid] = useState("");
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [Modaldata,setModaldata]=useState({})
   console.log("modaldata",Modaldata);
   
    const getVehicle = async () => {
        try {
            let res = await axios.get("https://vrpmpro.com/api/user/inquiries");
            if (res.status == 200) {
                setVehicleTypes(res.data.inquiries)
            }
        } catch (error) {
            console.log(error);

        }
    }

    useEffect(() => {
        getVehicle();
    }, []);

//     let [Contactus, setContactus] = useState([]);
//   const getContact = async () => {
//     try {
//       const getdata = await axios.get(
//         "https://vrpmpro.com/api/user/inquiry"
//       );
//       if (getdata) {
//         setContactus(getdata.data.inquiry);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   useEffect(() => {
//     getContact();
//   }, []);

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            Showing {from} to {to} of {size} Results
        </span>
    );


    // console.log("vehicleTypes",vehicleTypes);

    const { SearchBar, ClearSearchButton } = Search;
    const { ExportCSVButton } = CSVExport;
    const options = {
        paginationSize: 4,
        pageStartIndex: 0,
        firstPageText: "First",
        prePageText: "Back",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        prePageTitle: "Pre page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        showTotal: true,
        paginationTotalRenderer: customTotal,
        disablePageTitle: true,
        sizePerPageList: [
            {
                text: "5",
                value: 5,
            },
            {
                text: "10",
                value: 10,
            },
            {
                text: "All",
                value: vehicleTypes.length,
            },
        ], // A numeric array is also available. the purpose of above example is custom the text
    };
    const [typeName, setTypeName] = useState("");
    const [description, setDescription] = useState("");
    const [typeImage, setTypeImage] = useState(null);
    const [price, setPrice] = useState("");
    const [gst, setGst] = useState("");
    const [editShow, seteditshow] = useState(false);

    const columns = [
        {
            text: "S.No",
            sort: true,
            formatter: (cell, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1}
                    </div>
                )
            }
        },
        {
            dataField: "name",
            text: "Name",
            // formatter: (cell, row, rowIndex) => {
            //     return (
            //         <div>
            //             {row?.typeImage && <img src={`https://vrpmpro.com/vehicletypes/${row?.typeImage}`} style={{ width: "100px", height: "auto", borderRadius: "10px" }} />}
            //         </div>
            //     )
            // }

        },
        {
            dataField: "email",
            text: "Email",

        },

        {
            dataField: "phone",
            text: "Mobile",
            sort: true,
        },
        {
            dataField: "inquirytype",
            text: "Inquiry Type",

        },
        {
            dataField: "service",
            text: "Service",

        },
        {
            dataField: "city",
            text: "City",

        },
        // {
        //     dataField: "warehousesize",
        //     text: "Warehousesize",

        // },

        {
            dataField: "gst",
            text: "All Details",
            formatter: (cee, row) => {
                return <div className="d-flex gap-2">

                    {/* <abbr title="Edit" className="btn btn-outline-primary" style={{ cursor: "pointer" }} onClick={() => {
                        setTypeName(row?.typeName)
                        setDescription(row?.description);
                        setPrice(row?.price);
                        setGst(row?.gst)
                        seteditid(row?._id);
                        seteditshow(true);
                    }} >
                        <FaEdit size={25} />
                    </abbr> */}
                  
                    <Button onClick={()=>{
                        seteditshow(true);
                        setModaldata(row);
                    }}>< BsEyeFill /></Button> 
                    {/* <div onClick={()=>{setModaldata(true)}}>{Modaldata?.status}</div> */}

                    {/* <abbr title="Delete" className="btn btn-outline-danger" style={{ cursor: "pointer" }}>
                        <FaCheck size={25} />
                    </abbr> */}

                </div>
            }

        },

    ]
    const defaultSorted = [{
        dataField: 'propertytype',
        order: 'desc'
    }];



    const handleImageChange = (e) => {
        setTypeImage(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let check = vehicleTypes.filter((ele) => ele?.typeName == typeName && ele?.description == description);
        if (check.length != 0) return alert("Type of Vehicle already exits");

        // Prepare form data
        const formData = new FormData();
        formData.append("typeName", typeName);
        formData.append("description", description);
        formData.append("typeImage", typeImage);
        formData.append("price", price);
        formData.append("gst", gst);

        try {
          
            const response = await axios.post(
                "https://vrpmpro.com/api/admin/vehicle-types",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log(response.data);
            alert("Vehicle type added successfully!");
            handleClose()
            setTypeName('')
            setDescription('');
            setPrice('');
            setGst('');
            setTypeImage("")
            getVehicle()
        } catch (error) {
            // Handle errors
            console.error("Error submitting form", error);
            alert("Error submitting form. Please try again.");
        }
    };

    const handleEdit = async (e) => {
        e.preventDefault();

        let check = vehicleTypes.filter((ele) => ele?.typeName == typeName && ele?.description == description && ele?._id != editid);
        if (check.length != 0) return alert("Type of Vehicle already exits");

        // Prepare form data
        const formData = new FormData();
        formData.append("typeName", typeName);
        formData.append("description", description);
        formData.append("typeImage", typeImage);
        formData.append("price", price);
        formData.append("gst", gst);

        try {
      
            const response = await axios.put(
                "https://vrpmpro.com/api/admin/vehicle-types/" + editid, 
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log(response.data);
            alert("Vehicle type updated successfully!");
            seteditshow(false)
            setTypeName('')
            setDescription('');
            setPrice('');
            setGst('');
            setTypeImage("")
            getVehicle()
        } catch (error) {
            // Handle errors
            console.error("Error submitting form", error);
            alert("Error submitting form. Please try again.");
        }
    };


    return (
        <div className="ml-4">
            <h1 className="pt-4 pb-3" style={{ color: "white" }}>Enquiry</h1>
            <div className="container">
                <div className="card card-body">
                    <ToolkitProvider
                        keyField="id"
                        data={vehicleTypes}
                        columns={columns}
                        defaultSorted={defaultSorted}
                        search
                        exportCSV={{
                            fileName: "properties.csv",
                            blobType: "text/csv;charset=ansi",
                        }}
                    >
                        {(props) => (
                            <div>
                                <span className="pr-5 mr-auto">
                                    <ExportCSVButton
                                        className="btn-outline-success"
                                        {...props.csvProps}
                                    >
                                        Export to CSV
                                    </ExportCSVButton>
                                </span>
                                {"     "}
                                <span className="ps-5 ml-5 mt-3">
                                    <SearchBar
                                        className="form-control "
                                        {...props.searchProps}
                                    />
                                </span>
                                {"      "}
                                <ClearSearchButton
                                    className="btn-outline-info ms-5 "
                                    {...props.searchProps}
                                />
                                {/* <span className="ps-5 ml-5 mt-3">
                                    <button className='btn btn-outline-danger' onClick={handleShow}>Add Vehicle Type</button>
                                </span> */}

                                <hr />
                                <div className="table-responsive">
                                    <BootstrapTable
                                        keyField="patient"
                                        responsive
                                        hover
                                        columns={columns}
                                        data={vehicleTypes}
                                        pagination={paginationFactory(options)}
                                        {...props.baseProps}
                                    />
                                </div>
                            </div>
                        )}
                    </ToolkitProvider>
                </div>
            </div>
            {/* Modal */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Vehicle Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div class="container mt-2">
                        <form onSubmit={handleSubmit}>

                            <div class="mb-3">
                                <label for="typeName" class="form-label">Vehicle Type</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="typeName"
                                    value={typeName}
                                    placeholder="Enter type name (e.g., Mini Truck, Tempo)"
                                    required
                                    onChange={(e) => setTypeName(e.target.value)}
                                />
                            </div>


                            <div class="mb-3">
                                <label for="description" class="form-label">Description</label>
                                <input type="text"
                                    class="form-control"
                                    id="description"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Ex- 3 Wheeler (5.5 ft)"
                                />
                            </div>


                            <div class="mb-3">
                                <label for="typeImage" class="form-label">Vehicle Image</label>
                                <input
                                    type="file"
                                    class="form-control"
                                    id="typeImage"
                                    required
                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                            </div>

                            <div class="mb-3">
                                <label for="price" class="form-label">Price</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="price"
                                    placeholder="Enter price"
                                    min="0"
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                />
                            </div>


                            <div class="mb-3">
                                <label for="gst" class="form-label">GST</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="gst"
                                    placeholder="Enter GST ex:- 80"
                                    min="0"
                                    value={gst}
                                    onChange={(e) => setGst(e.target.value)}
                                />
                            </div>

                            <button type="submit" class="btn btn-outline-success">Submit</button>
                        </form>
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-outline-danger" onClick={handleClose}>
                        Close
                    </button>
                    {/* <button className="btn btn-outline-success" onClick={handleClose}>
                        Save Changes
                    </button> */}
                </Modal.Footer>
            </Modal>

            {/* Modal */}
            {/* <Modal show={editShow} onHide={() => seteditshow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Vehicle Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div class="container mt-2">
                        <form onSubmit={handleEdit}>

                            <div class="mb-3">
                                <label for="typeName1" class="form-label">Vehicle Type</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="typeName1"
                                    value={typeName}
                                    placeholder="Enter type name (e.g., Mini Truck, Tempo)"
                                    required
                                    onChange={(e) => setTypeName(e.target.value)}
                                />
                            </div>


                            <div class="mb-3">
                                <label for="description1" class="form-label">Description</label>
                                <input type="text"
                                    class="form-control"
                                    id="description1"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Ex- 3 Wheeler (5.5 ft)"
                                />
                            </div>


                            <div class="mb-3">
                                <label for="typeImage1" class="form-label">Vehicle Image</label>
                                <input
                                    type="file"
                                    class="form-control"
                                    id="typeImage1"

                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                            </div>

                            <div class="mb-3">
                                <label for="price1" class="form-label">Price</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="price1"
                                    placeholder="Enter price"
                                    min="0"
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                />
                            </div>


                            <div class="mb-3">
                                <label for="gst1" class="form-label">GST</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="gst1"
                                    placeholder="Enter GST ex:- 80"
                                    min="0"
                                    value={gst}
                                    onChange={(e) => setGst(e.target.value)}
                                />
                            </div>

                            <button type="submit" class="btn btn-outline-success">Save Changes</button>
                        </form>
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-outline-danger" onClick={() => seteditshow(false)}>
                        Close
                    </button>
                 <button className="btn btn-outline-success" onClick={handleClose}>
                        Save Changes
                    </button> 
                </Modal.Footer>
            </Modal>
             */}
           <Modal show={editShow} onHide={() => seteditshow(false)} className="w-100">
  <Modal.Header closeButton>
    <Modal.Title>All Details</Modal.Title>
  </Modal.Header>
  <Modal.Body>
  <div className="container mt-2 border">
  {/* {details.map((detail, index) => (
            <tr key={index}> */}
            {/* {vehicleTypes.map((item)=>{
                return (
                    <div>
                        <p><b>Name: </b> {item?.name}</p> 
                    </div>
                )
            })} */}
     <p><b>Name: </b> {Modaldata?.name}</p>
     <p><b>Phone: </b>{Modaldata?.phone} </p>
     <p><b>Email: </b> {Modaldata?.email}</p>
     <p><b>Inquiry Type: </b>{Modaldata?.inquirytype}</p>
     {(Modaldata.inquirytype==="WareHouse")? <p><b>WarehouseSize: </b>{Modaldata?.warehousesize}</p>:null}
     <p><b>Service: </b> {Modaldata?.service}</p>
     <p><b>Message: </b> {Modaldata?.message}</p>
     {/* <p><b>Status: </b> {Modaldata?.status}</p> */}

 {/*
         
        
         
    </div>
       <div className="container  border">  <h5>Message  {details.message}</h5></div>*/}
            {/* </tr>
          ))}  */}
</div>
  </Modal.Body>
  <Modal.Footer>
    <button className="btn btn-outline-danger" onClick={() => seteditshow(false)}>
      Close
    </button>
  </Modal.Footer>
</Modal>

        </div>

    );
};

export default AdminEnquiry;
